module.exports = __webpack_public_path__ + "static/media/si_8.b66bdf63.JPG";